export enum CallAnalyticsAnalyticsEvents {
  TranscriptionSelected = 'transcription_selected',
}
